import { gql } from '@apollo/client';

export const UNIFIED_SEARCH = gql`
  query UnifiedSearch($searchTerm: String!, $limit: Int) {
    opportunities(
      name: $searchTerm
      first: $limit
      onlyActiveOpportunities: true
    ) {
      edges {
        node {
          id
          name
          status
          statusDisplay
          stage
          stageDisplay
          pipeline
          projectName
          closingDate
        }
      }
    }
  }
`;
